import { lazy, Suspense } from 'react';
import { useResponsiveComponent } from '@/hooks/useResponsiveComponent';

// Lazy load mobile and desktop components
const FavoritesPage = lazy(() => import('./buyer/FavoritesPage').then(module => ({ default: module.FavoritesPage })));
const DesktopFavoritesPage = lazy(() => import('./desktop/DesktopFavoritesPage').then(module => ({ default: module.DesktopFavoritesPage })));

// Loading component for suspense fallback
function FavoritesPageLoader() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-[#86DB89] rounded-full animate-spin"></div>
        <p className="text-[#666666] text-base">페이지를 불러오는 중...</p>
      </div>
    </div>
  );
}

/**
 * Responsive wrapper that automatically switches between mobile and desktop
 * versions of the FavoritesPage based on screen size (1024px breakpoint)
 */
export function ResponsiveFavoritesPage() {
  const isDesktop = useResponsiveComponent(1024);

  return (
    <Suspense fallback={<FavoritesPageLoader />}>
      {isDesktop ? <DesktopFavoritesPage /> : <FavoritesPage />}
    </Suspense>
  );
}